/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Spin } from 'antd';
import React from 'react';
import { ReactComponent as Info } from '@assets/svg/icons/logbook/Info.svg';
import { FilterDictionary } from '@common/constants/logbook';
import { FilterActionTypes, useFilterContext } from '@context/logbook/filter.context';
import { useLogbookContext } from '@context';
import Tag from '../Tag';
import './index.scss';

const FiltersBlock: React.FC = () => {
  const { filtersState, filterDispatch, selectedFilters, isFilterLoading } = useFilterContext();
  const { tableDispatch } = useLogbookContext();

  const handleFilterChange = (title: string, option: string) => {
    filterDispatch({ type: FilterActionTypes.CHANGE_FILTER, payload: { title, option } });
    tableDispatch({ type: 'initial' });
  };

  const handleClear = () => {
    filterDispatch({ type: FilterActionTypes.CLEAR_ALL });
    tableDispatch({ type: 'initial' });
  };

  const handleCancel = (title: string) => {
    filterDispatch({ type: FilterActionTypes.CLEAR_ONE, payload: title });
    tableDispatch({ type: 'initial' });
  };

  return (
    <Spin spinning={isFilterLoading}>
      <div className="filters-section-container">
        <div className="filter-container">
          <div className="filters">
            {filtersState.filters.map((i, index) => (
              <div key={index} className="filter">
                <select
                  value={i.selected}
                  onChange={(e) => handleFilterChange(i.title, e.target.value)}
                >
                  <option selected={!i.selected} disabled>
                    {FilterDictionary[i.title]?.toUpperCase() || i.title}
                  </option>
                  {i.options.map((j) => (
                    <option key={j.value} value={j.value}>
                      {j.value}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
          <p onClick={handleClear} className="filters-clear">
            Clear all filters
          </p>
        </div>
        {selectedFilters.length === 0 ? (
          <div className="empty-tags-container">
            <Info />
            <p className="empty-tags-label">All categories are chosen</p>
          </div>
        ) : (
          <div style={{ display: 'flex' }}>
            {selectedFilters.map((i, index) => (
              <div key={index} style={{ marginRight: 20 }}>
                <Tag
                  title={i.title.replace('_', ' ') || i.title}
                  value={i.selected}
                  onCancel={() => handleCancel(i.title)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </Spin>
  );
};

export default FiltersBlock;
